import Alpine from 'alpinejs';

import { isMotionFull, subscribeMotion } from '../motion';

type LiquidGradientData = {
  curX: number;
  curY: number;
  tgX: number;
  tgY: number;
  frameId: number | null;
  onMove: ((event: MouseEvent) => void) | null;
  unsubscribe: (() => void) | null;
  init(this: LiquidGradientData & { $refs: Record<string, HTMLElement> }): void;
  start(
    this: LiquidGradientData & { $refs: Record<string, HTMLElement> },
  ): void;
  stop(this: LiquidGradientData & { $refs: Record<string, HTMLElement> }): void;
  destroy(
    this: LiquidGradientData & { $refs: Record<string, HTMLElement> },
  ): void;
};

export const registerLiquidGradient = (): void => {
  Alpine.data(
    'liquidGradient',
    (): LiquidGradientData => ({
      curX: 0,
      curY: 0,
      tgX: 0,
      tgY: 0,
      frameId: null,
      onMove: null,
      unsubscribe: null,

      init() {
        const sync = (): void => {
          if (isMotionFull()) {
            this.start();
          } else {
            this.stop();
          }
        };

        sync();
        this.unsubscribe = subscribeMotion(sync);
      },

      start() {
        const interactive = this.$refs.interactive as HTMLElement | undefined;
        if (!interactive || this.frameId !== null) {
          return;
        }

        this.onMove = (event: MouseEvent): void => {
          this.tgX = event.clientX;
          this.tgY = event.clientY;
        };

        const move = (): void => {
          this.curX += (this.tgX - this.curX) / 20;
          this.curY += (this.tgY - this.curY) / 20;
          interactive.style.transform = `translate(${Math.round(this.curX)}px, ${Math.round(this.curY)}px)`;
          this.frameId = requestAnimationFrame(move);
        };

        window.addEventListener('mousemove', this.onMove);
        this.frameId = requestAnimationFrame(move);
      },

      stop() {
        if (this.frameId !== null) {
          cancelAnimationFrame(this.frameId);
          this.frameId = null;
        }
        if (this.onMove) {
          window.removeEventListener('mousemove', this.onMove);
          this.onMove = null;
        }

        const interactive = this.$refs.interactive as HTMLElement | undefined;
        if (interactive) {
          interactive.style.transform = '';
        }
      },

      destroy() {
        this.unsubscribe?.();
        this.unsubscribe = null;
        this.stop();
      },
    }),
  );
};
